import { makeAutoObservable, toJS } from "mobx"
import type AppStore from "../../stores/AppStore"

export const defaultJobCard: IJobCard = {
  id: "",
  uniqueId: "",
  taskDescription: "",
  jobcardType: "General",
  jobcardCost: 0,
  dueDate: Date.now(),
  dateIssued: 0,
  urgency: "Normal",
  status: "Not Started",
  objectives: "",
  expectedOutcomes: "",
  division: "",
  section: "",
  erf: "",
  typeOfWork: "",
  assignedTo: "",
  artesian: "",
  teamLeader: "",
  teamMembers: [],
  remark: "",
  measure: "",
  acknowledged: false,
  title: "",
  description: "",
  priority: "Normal",
  assignedUserId: "",
  divisionId: "",
  sectionId: "",
  dateCreated: Date.now(),
  createdAt: Date.now(),
  updatedAt: Date.now(),
}

export interface IJobCard {
  id: string
  assignedTo: string
  uniqueId: string
  taskDescription: string
  jobcardType: IJobCardType
  jobcardCost: number
  dueDate: number
  dateIssued: number
  urgency: IUrgency
  status: IStatus
  acknowledged: boolean
  objectives: string
  expectedOutcomes: string
  division: string
  section: string
  erf: string
  typeOfWork: string
  artesian: string
  teamLeader: string
  teamMembers?: string[]
  remark: string
  measure: string
  isAllocated?: boolean
  comment?: string
  clientRating?: number
  teamRating?: number
  dateCompleted?: number
  clientId?: string
  isDuplicated?: boolean
  isDuplicatedCount?: number
  materials?: IMaterial[]
  title?: string
  description?: string
  priority?: string
  assignedUserId?: string
  divisionId?: string
  sectionId?: string
  dateCreated?: number
  dateStarted?: number
  createdAt?: number
  updatedAt?: number
}

export type IStatus = "Not Started" | "In Progress" | "Completed" | "Assigned" | "Deleted" | "Pending" | "Cancelled"

export type IUrgency = "Normal" | "Urgent" | "Very Urgent"
export type IJobCardType = "Ad-hoc" | "Sewer" | "Roads" | "Building" | "General"

export type IMaterialType =
  | "Tools"
  | "Equipment"
  | "Raw Materials"
  | "Safety Equipment"
  | "Consumables"
  | "Parts"
  | "Other"

export interface IMaterial {
  id: string
  name: string
  unitCost: number
  quantity: number
  jId?: string
  materialTypes: IMaterialType[]
}

export const defaultMaterial: IMaterial = {
  id: "",
  quantity: 0,
  name: "",
  unitCost: 0,
  jId: "",
  materialTypes: [],
}

export default class JobCardModel {
  private JobCard: IJobCard

  constructor(
    private store: AppStore,
    JobCard: IJobCard,
  ) {
    makeAutoObservable(this)
    this.JobCard = JobCard
  }

  get asJson(): IJobCard {
    return toJS(this.JobCard)
  }
}
